function hideRewardTypeField(element, value) {
  const rowDiv = $("#" + element).parents(".grey-border");

  const freeCoinFields = rowDiv.find(".free-coin");
  const rewardItemFields = rowDiv.find(".reward-item");
  const itemImageField = rowDiv.find("input[id*='image']").parents(".col-lg-6");
  const quantityLabel = rowDiv.find("label[for*='quantity']");

  if (value === "reward_item") {
    quantityLabel.html("<label>Qty per Win</label>");
    freeCoinFields.hide();
    rewardItemFields.show();
    itemImageField.show();
  } else if (value === "free_coin") {
    quantityLabel.html("<label>Stock Qty</label>");
    rewardItemFields.hide();
    freeCoinFields.show();
    itemImageField.show();
  } else if (value === "try_again") {
    freeCoinFields.hide();
    rewardItemFields.hide();
    itemImageField.hide();
  }
}

function hidePrizeTypeField(element, value) {
  const rowDiv = $("#" + element).parents(".grey-border");
  const grandPrizeFields = rowDiv.find("div[id*='grand-prize']");

  if (value === "normal") {
    grandPrizeFields.hide();
  } else if (value === "grand") {
    grandPrizeFields.show();
  }
}

function load_catalogues(element, value) {
  const reward_id = $("#" + element).val();
  const selRewardDiv = $("#" + element).parents(".row");
  const catalogueField = selRewardDiv.find("select[id*='catalogue_id']");
  const rowDiv = $("#" + element).parents(".grey-border");
  const nameField = rowDiv.find("input[id*='name']");
  // const descriptionField = rowDiv.find("input[id*='description']");

  $.ajax({
    url: "/rewards/" + reward_id + "?format=json",
    type: "get",
    data: "",
    success: function (data) {
      nameField.val(data["name"]);
    },
    error: function (data) {},
  });

  $.ajax({
    url:
      "/rewards/" + reward_id + "/catalogues/available_catalogues?format=json",
    type: "get",
    data: "",
    success: function (data) {
      catalogueField.empty();
      catalogueField.append("<option value></option>");
      for (var i = 0; i < data.length; i++) {
        catalogueField.append(
          "<option value='" +
            data[i]["id"] +
            "'>" +
            data[i]["title"] +
            "</option>"
        );
      }
    },
    error: function (data) {
      catalogueField.empty();
    },
  });
}

function load_catalogue_details(element, value) {
  const catalogueId = $("#" + element).val();
  const selCatalogueDiv = $("#" + element).parents(".row");
  const rewardId = selCatalogueDiv.find("select[id*='reward']").val();
  const rowDiv = $("#" + element).parents(".grey-border");
  // const descriptionField = rowDiv.find("input[id*='description']");
  const stockQtyField = rowDiv.find("input[id*='catalogue_stock_qty']");
  const availableQtyField = rowDiv.find("input[id*='available_qty']");

  $.ajax({
    url: "/rewards/" + rewardId + "/catalogues/" + catalogueId + "?format=json",
    type: "get",
    data: "",
    success: function (data) {
      stockQtyField.val(data["allocated_count"]);
      availableQtyField.val(data["available_count"]);
    },
    error: function (data) {},
  });
}

function calculate_remainder() {
  let remainder = 100;
  $(".nested-fields:visible .percent").each(function () {
    let value = $(this).val();
    if (value == "") {
      value = 0;
    }
    remainder -= value;
    remainder = +(Math.round(remainder + "e+2") + "e-2");
  });
  const remainderElement = document.getElementById("remainder");
  if (remainderElement) {
    remainderElement.innerHTML = "Remaining %: " + remainder;
  }
  return remainder;
}

function validate_percentage() {
  const remainder = calculate_remainder();
  if (remainder > 100) {
    alert("Win percentage should not be negative value!");
    return false;
  }

  if (remainder < 0) {
    alert("Total win percentage should not greater than 100%");
    return false;
  }
}

function set_background_color(element, value) {
  $("#" + element).css("background-color", value);
}

function update_fields_text(element) {
  const rowDiv = $("#" + element).parents(".grey-border");
  const nameField = rowDiv.find("input[id*='name']");
  const winTitleField = rowDiv.find("input[id*='win_title']");
  const winMessageField = rowDiv.find("input[id*='win_message']");
  const winTitle1Field = rowDiv.find("input[id*='win_title1']");
  const winMessage1Field = rowDiv.find("input[id*='win_message1']");
  const winType = rowDiv.find("input[id*=win_type]:checked").val();
  const prizeType = rowDiv.find("input[id*=prize_type]:checked").val();

  if (winType === "reward_item") {
    let catalogue = rowDiv
      .find("select[id*='catalogue_id'] option:selected")
      .text();
    let quantity = rowDiv.find("input[id*='quantity']").val();
    if (quantity <= 1) {
      nameField.val(catalogue);
    } else {
      nameField.val(`${quantity} X ${catalogue}`);
    }
    winTitleField.val("CONGRATULATIONS!");
    winMessageField.val(`You've won ${quantity} X ${catalogue}!`);
    winTitle1Field.val("Congratulations!");
    winMessage1Field.val(
      `You've won ${quantity} X ${catalogue}, you can find it in your wallet along with redemption details!`
    );
  } else if (winType === "free_coin") {
    let coinValue = rowDiv.find("input[id*='coin_value']").val();
    nameField.val(coinValue + " Coins");
    winTitleField.val("CONGRATULATIONS!");
    winMessageField.val(`You have won ${coinValue} coins!`);
    winTitle1Field.val("Congratulations!");
    winMessage1Field.val(`You have won ${coinValue} coins!`);
  } else if (winType === "try_again") {
    let try_again = "Please try again!";
    let better_luck = "Better luck next time!";
    nameField.val(try_again);
    winTitleField.val("Sorry!");
    winMessageField.val(better_luck);
    winTitle1Field.val("Sorry!");
    winMessage1Field.val(better_luck);
  }

  if (prizeType === "grand") {
    winTitle1Field.val("That's a GRAND PRIZE!");
  } else {
    winTitle1Field.val("Congratulations!");
  }
}

$(document).ready(function () {
  calculate_remainder();

  $(".prize-types input[type=radio]:checked").each(function () {
    hidePrizeTypeField(this.id, this.value);
  });

  $(document).on(
    "change",
    ".prize-types input[type=radio]:checked",
    function () {
      hidePrizeTypeField(this.id, this.value);
      update_fields_text(this.id);
    }
  );

  $(".reward-types input[type=radio]:checked").each(function () {
    hideRewardTypeField(this.id, this.value);
  });

  $(document).on(
    "change",
    ".reward-types input[type=radio]:checked",
    function () {
      hideRewardTypeField(this.id, this.value);
      update_fields_text(this.id);
    }
  );

  $(document).on("change", ".sel_reward select", function () {
    load_catalogues(this.id, this.value);
  });

  $(document).on("change", "select[id*=catalogue_id]", function () {
    load_catalogue_details(this.id, this.value);
    update_fields_text(this.id);
  });

  $(document).on("keyup", ".percent", function () {
    calculate_remainder();
  });

  $(document).on("keyup", ".update_fields_text input", function () {
    update_fields_text(this.id);
  });

  $(document).on("change", ".update_fields_text select", function () {
    update_fields_text(this.id);
  });

  $(document).on("click", "input[type=submit]", function (e) {
    if (validate_percentage() === false) e.preventDefault();
  });

  $(document).on("keypress", ".positive_only", function (e) {
    e = e || window.event;
    let charCode = e.which || e.keyCode;
    let charStr = String.fromCharCode(charCode);
    if (charStr == "-") e.preventDefault();
  });

  $(document).on("keyup", "input[id*=prize_color]", function (e) {
    set_background_color(this.id, this.value);
  });
});
